import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {competencyById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  allOrdersCountOrgById,
  newOrdersCountFrontlineById,
  newOrdersCountGen0ById,
  newOrdersCountOrgById,
  ordersCountFrontlineById,
  ordersCountGen0ById,
  ordersCountOrgById,
} from '/redux/selector/metric.clients.selector';
import {withProps} from '/util/selector.util';

import OrdersMetricsSection from './OrdersMetricsSection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    currentUserCompetency: withCoachUserId(competencyById),
    newOrdersCountFrontline: withCoachUserId(newOrdersCountFrontlineById),
    newOrdersCountGen0: withCoachUserId(newOrdersCountGen0ById),
    newOrdersCountOrg: withCoachUserId(newOrdersCountOrgById),
    ordersCountFrontline: withCoachUserId(ordersCountFrontlineById),
    ordersCountGen0: withCoachUserId(ordersCountGen0ById),
    ordersCountOrg: withCoachUserId(ordersCountOrgById),
    allOrdersOrgCount: withCoachUserId(allOrdersCountOrgById),
  }),
)(OrdersMetricsSection);
